import { Link } from '@/ui/Link'
import { Message } from '@/ui/Message/Message'
import { PropsWithChildren } from 'react'
import styles from './FoilMessage.module.scss'

export interface FoilMessageProps {
  foilSuite: string
}

export function FoilMessage({ foilSuite }: PropsWithChildren<FoilMessageProps>) {
  if (!foilSuite) return null

  const href = `/product${foilSuite}`
  return (
    <Message size="sm" data-testid="foil-message" color={'blue'} className={styles.message}>
      <Message.Content>
        <Message.Text className={styles.messageText}>
          See how your cards shine with a &nbsp;
          <Link size="sm" color="secondary" href={href}>
            touch of foil.
          </Link>
        </Message.Text>
      </Message.Content>
    </Message>
  )
}
